import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import rest from '../../../lib/rest'
import FormPlanoContas from './formPlanoContas'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'

const PlanoContas  = () => {
  const colunas = [
    {
      dataField: 'plano_contas_id',
      text: 'Código'
    },
    {
      dataField: 'plano_contas',
      text: 'Plano de Contas'
    }
  ]

  const { SearchBar }             = Search
  const [modal, setModal]         = useToggle()
  const [loading, setLoading]     = useState(true)
  const [filial_id, setFilial_id] = useState('')

  const [listaPlanoConta, setPlanoContas] = useState([])
  const [planoContas_id, setPlanoContas_id]     = useState('')

  const listaPlanoContas = () => {
    let lista = []
    const url = rotas.planoContas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S'){
          lista = ret.lista
          setPlanoContas(lista)
        }
        setLoading(false);
      })
      return (lista)

    }catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    listaPlanoContas();
  }, [filial_id])

  useEffect(() => {
    const load = loading;
    if (load === true) {
      listaPlanoContas();
    }
  }, [])

  //limpa formulario
  const abreModal = (plano_contas_id) => {
    setPlanoContas_id(plano_contas_id)
    setModal()
  }

  useEffect(() => {
    if(modal===false){
      listaPlanoContas()
    }
  }, [modal])

  if (loading) {
    return (
      <Loading tipo='paginas' />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>CADASTRO DE PLANO DE CONTAS</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>

                  <Modal
                    size    = 'lg'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Cadastro de Plano de Contas</ModalHeader>
                    <FormPlanoContas
                      fechaModal      = {setModal}
                      planoContas_id  = {planoContas_id}
                    >
                    </FormPlanoContas>
                  </Modal>

                  <ToolkitProvider
                    search
                    keyField  = "plano_contas_id"
                    data      = {listaPlanoConta}
                    columns   = {colunas}
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  outline
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal('')}
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Plano de Contas..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            keyField          = 'plano_contas_id'
                            noDataIndication  = "Nenhum registro encontrado"
                            rowStyle          = {{ cursor: "pointer" }}
                            pagination        = {paginationFactory({
                                                  sizePerPage: 10,
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                            rowEvents         = {{onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(row.plano_contas_id)
                                                  }
                                                }}
                            {...props.baseProps}
                          />
                          <br />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default PlanoContas;
